import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import SHSForm from '../utils/shs-form'
import InputElement from '../utils/input'

import { registerWithEmailAndPass } from '../../actions/auth'

import { routes } from '../../constants/routes'

const Register = ({ dispatch, fireauth }) => {
    const successFX = () => {
        // nothing for now
    }

    const submitFX = (formData, formId) => {
        dispatch(registerWithEmailAndPass(fireauth, formData.email, formData.password, formId))
    }

    return (
        <div className="box m-auto w-50 mt-5">
            <h1>Register</h1>
            <SHSForm submitFX={submitFX} successFX={successFX} buttonLabel="Register">
                <InputElement
                    type="email"
                    id="email"
                    placeholder="user@example.com"
                    label="Email Address"
                    errorMessage="Please provide a valid email address"
                    required />
                <InputElement
                    type="password"
                    id="password"
                    placeholder="A secret word or phrase"
                    label="Password"
                    errorMessage="Password is required to be a minimum of 8 characters" />
            </SHSForm>
            <p>Already have an account? <Link to={routes.authLogin}>Login</Link></p>
        </div>
    )
}

export default connect()(Register)
